import type { SVGProps } from 'react'

interface ForestIconProps extends SVGProps<SVGSVGElement> {}

export function ForestIcon(props: ForestIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M300-134.62V-260H104.16q-21.7 0-31.73-19.08-10.04-19.08 1.8-37.15L194-500h-7.69q-21.08 0-31.62-18.77-10.53-18.77 2.31-36.85L330.08-803q10.84-15.46 29.92-15.46 19.08 0 29.92 15.46L480-673.38 570.08-803q10.84-15.46 29.92-15.46 19.08 0 29.92 15.46L803-555.62q12.84 18.08 2.31 36.85Q794.77-500 773.69-500H766l119.77 183.77q11.84 18.07 1.8 37.15Q877.54-260 855.84-260H660v123.84q0 15.47-10.35 25.81Q639.31-100 623.84-100h-49.22q-14.7 0-24.66-9.96T540-134.62V-260H420v123.84q0 15.47-10.35 25.81Q399.31-100 383.84-100h-49.22q-14.7 0-24.66-9.96T300-134.62zM643.61-320h168.85L655.54-560H726L600-740l-82.92 118.31 46.3 66.07q12.46 18.08 2.12 36.85Q555.15-500 534.07-500H526l117.61 180zm-496.07 0h424.92L415.54-560H486L360-740 234-560h70.46L147.54-320zm0 0h156.92H234h252-70.46 156.92-424.92zm496.07 0H526h75.54-84.46H726h-70.46 156.92-168.85zM540-260h120-120zm142.92 0z" />
    </svg>
  )
}
